import React, { useEffect, useState } from "react";
import styled from "styled-components";
import axios from "axios";
import { Link } from "react-router-dom";
import { TfiClose, TfiPlus, TfiAngleLeft } from "react-icons/tfi";
import {
  api_v3_get_classification,
  api_v3_get_tournament_by_id,
  api_v3_update_players_to_group,
  api_v3_get_matches_by_tournament_division_group,
  api_v3_delete_matches_by_group,
  api_v3_generate_matches_round_robin,
  api_v3_publish_matches_by_league_day,
  PLAYERDESCANSA,
} from "../utils/constants";
import { useNavContext } from "../context/nav_context";
import { useRegistrationsContext } from "../context/registrations_context";
import { Loading } from "../components";

const AdminGroupPlayerList = ({ context }) => {
  const {
    regInProgress,
    regError,
    allRegistrations,
    updateCurrentTournamentNoGroupFilter,
    current_tournament,
  } = useRegistrationsContext();

  const { tournamentId, divisionId, groupId } = context;
  const { accessToken } = useNavContext();
  const groupIdentifier = groupId.groupId;

  const [registersNotInGroup, setRegistersNotInGroup] = useState([]);
  const [registersInGroup, setRegistersInGroup] = useState([]);
  const [numRegistersInGroup, setNumRegistersInGroup] = useState(0);

  const [groupInProgress, setGroupInProgress] = useState(false);
  const [groupError, setGroupError] = useState(false);
  const [groupName, setGroupName] = useState("");
  const [saveBtnInProgress, setSaveBtnInProgress] = useState(false);
  const [saveBtnDone, setSaveBtnDone] = useState(false);
  const [saveBtnError, setSaveBtnError] = useState(false);

  const [divisionsInProgress, setDivisionsInProgress] = useState(false);
  const [divisionsError, setDivisionsError] = useState(false);
  const [, setDivisions] = useState([]);

  const [matchesInProgress, setMatchesInProgress] = useState(true);
  const [matchesError, setMatchesError] = useState(false);
  const [matches, setMatches] = useState([]);
  const [deleteInProgress, setDeleteInProgress] = useState(false);
  const [deleteError, setDeleteError] = useState(false);
  const [generateMatchesInProgress, setGenerateMatchesInProgress] =
    useState(false);
  const [generateMatchesError, setGenerateMatchesError] = useState(false);

  const [publishLeagueDayBtnInProgress, setPublishLeagueDayBtnInProgress] =
    useState(false);
  const [publishLeagueDayBtnError, setPublishLeagueDayBtnError] =
    useState(false);
  const [publishLeagueDayBtnDone, setPublishLeagueDayBtnDone] = useState(false);
  const [descansaInGroup, setDescansaInGroup] = useState(false);

  // USE EFFECTS ---------
  useEffect(() => {
    if (tournamentId !== current_tournament) {
      updateCurrentTournamentNoGroupFilter(tournamentId);
    }
  }, [tournamentId, current_tournament, updateCurrentTournamentNoGroupFilter]);

  useEffect(() => {
    const loadDivisions = async (tournamentId) => {
      const url = api_v3_get_tournament_by_id(tournamentId);

      try {
        setDivisionsInProgress(true);
        const response = await axios.get(url);
        if (response.status === 200) {
          const divs = response.data.divisions.sort((a, b) =>
            a.sequence > b.sequence ? 1 : -1
          );
          setDivisions(divs);

          const division = divs.find(
            (division) => division.divisionId === divisionId
          );
          const group = division?.groups.find(
            (group) => group.groupId === groupId
          );

          const gName = group ? group.name : "";
          setGroupName(`${division.name} - ${gName}`);

          setDivisionsInProgress(false);
          setDivisionsError(false);
          return true;
        } else {
          console.log(`(${response.status}) response: ${response.data}`);
          setDivisionsInProgress(false);
          setDivisionsError(true);
          return false;
        }
      } catch (error) {
        setDivisionsInProgress(false);
        setDivisionsError(true);
        return false;
      }
    };
    const loadGroupDetails = async (tournamentId, divisionId, groupId) => {
      setGroupInProgress(true);
      const url = api_v3_get_classification(divisionId, groupId);

      try {
        setGroupInProgress(true);
        const response = await axios.get(url);
        if (response.status === 200) {
          const players = response.data.players.sort((a, b) =>
            a.username.toLowerCase() > b.username.toLowerCase() ? 1 : -1
          );

          setRegistersInGroup(players);
          setNumRegistersInGroup(players.length);
          setGroupInProgress(false);
          return true;
        } else {
          console.log(`(${response.status}) response: ${response.data}`);
          setGroupInProgress(false);
          setGroupError(true);
          return false;
        }
      } catch (error) {
        if (error.response && error.response.status === 404) {
          setGroupError(false);
          setRegistersInGroup([]);
          setGroupInProgress(false);
          return true;
        } else {
          setGroupInProgress(false);
          setGroupError(true);
          return false;
        }
      }
    };
    const loadMatches = async (tournamentId, divisionId, groupId) => {
      setMatchesInProgress(true);
      const url = api_v3_get_matches_by_tournament_division_group(
        tournamentId,
        divisionId,
        groupId
      );

      try {
        setMatchesInProgress(true);
        const response = await axios.get(url);
        if (response.status === 200) {
          const matches = response.data;

          setMatches(matches);
          setMatchesInProgress(false);
          return true;
        } else {
          console.log(`(${response.status}) response: ${response.data}`);
          setMatchesInProgress(false);
          setMatchesError(true);
          return false;
        }
      } catch (error) {
        if (error.response && error.response.status === 404) {
          setMatchesError(false);
          setMatches([]);
          setMatchesInProgress(false);
          return true;
        } else {
          setMatchesInProgress(false);
          setMatchesError(true);
          return false;
        }
      }
    };

    loadDivisions(tournamentId);
    loadGroupDetails(tournamentId, divisionId, groupId);
    loadMatches(tournamentId, divisionId, groupId);
    // eslint-disable-next-line
  }, [groupIdentifier]);

  useEffect(() => {
    if (
      allRegistrations.length > 0 &&
      registersInGroup &&
      registersInGroup.length > 0
    ) {
      const filteredApprobedRegsInTournament = allRegistrations.filter(
        (player) =>
          player.tournamentHistory.some(
            (tournament) =>
              tournament.tournamentId === tournamentId &&
              tournament.status === "APPROBED"
          )
      );

      var filteredRegs = [];
      for (var reg of filteredApprobedRegsInTournament) {
        var exists = false;

        for (var r of registersInGroup) {
          const rightId = reg.playerId ? reg.playerId : r.playerId;
          const leftId = r.playerId ? r.playerId : r.playerId;
          if (rightId === leftId) {
            exists = true;
            break;
          }
        }
        if (!exists) {
          filteredRegs.push(reg);
        }
      }
      setRegistersNotInGroup(
        filteredRegs.sort((a, b) =>
          a.username.toLowerCase() > b.username.toLowerCase() ? 1 : -1
        )
      );
    } else if (allRegistrations.length > 0) {
      const filteredApprobedRegsInTournament = allRegistrations.filter(
        (player) =>
          player.tournamentHistory.some(
            (tournament) =>
              tournament.tournamentId === tournamentId &&
              tournament.status === "APPROBED"
          )
      );
      setRegistersNotInGroup(filteredApprobedRegsInTournament);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allRegistrations, tournamentId]);

  useEffect(() => {
    if (publishLeagueDayBtnDone) {
      setTimeout(function () {
        setPublishLeagueDayBtnDone(false);
      }, 3000);
    }
  }, [publishLeagueDayBtnDone]);

  useEffect(() => {
    const isDescansaInGroup = registersInGroup.filter(
      (reg) => reg.username === "DESCANSA"
    );

    setDescansaInGroup(isDescansaInGroup.length > 0);
  }, [registersInGroup]);

  // FUNCTIONS -----------
  const addPlayerInGroup = (player) => {
    var temp = registersInGroup;
    temp.push(player);
    setNumRegistersInGroup(temp.length);
    setRegistersInGroup(
      temp.sort((a, b) =>
        a.username.toLowerCase() > b.username.toLowerCase() ? 1 : -1
      )
    );

    var regsNotInGroup = registersNotInGroup.filter(
      (p) => p.playerId !== player.playerId
    );
    setRegistersNotInGroup(regsNotInGroup);
  };

  const removePlayerFromGroup = (player) => {
    if (player.username !== "DESCANSA") {
      var temp = registersNotInGroup;
      temp.push(player);
      temp.sort((a, b) =>
        a.username.toLowerCase() > b.username.toLowerCase() ? 1 : -1
      );
      setRegistersNotInGroup(temp);
    }

    var regsInGroup = registersInGroup.filter(
      (p) =>
        (p.playerId ? p.playerId : p.playerId) !==
        (player.playerId ? player.playerId : player.playerId)
    );
    setRegistersInGroup(regsInGroup);
    setNumRegistersInGroup(regsInGroup.length);
  };

  const saveGroup = async () => {
    setSaveBtnInProgress(true);
    const url = api_v3_update_players_to_group(divisionId, groupId);
    try {
      console.log(`Saving....`);
      var access_token = accessToken || localStorage.getItem("access_token");
      if (!access_token) {
        console.error(
          `AdminGroupPlayerList :: saveGroup -> it's necessary be logged`
        );
        return false;
      }
      const config = {
        headers: { Authorization: `Bearer ${access_token}` },
      };
      var listOfPlayers = registersInGroup.map((reg) =>
        reg.playerId ? reg.playerId : reg.playerId
      );

      var data = listOfPlayers;
      console.log("data:");
      console.log(data);
      const response = await axios.put(url, data, config);
      if (response.status === 200) {
        setSaveBtnInProgress(false);
        setSaveBtnError(false);
        setSaveBtnDone(true);
        return true;
      } else {
        setSaveBtnInProgress(false);
        setSaveBtnDone(false);
        setSaveBtnError(true);
        console.log(
          `(${response.status}) response: ${JSON.stringify(response.data)}`
        );
        return false;
      }
    } catch (error) {
      setSaveBtnInProgress(false);
      setSaveBtnDone(false);
      setSaveBtnError(true);
      return false;
    }
  };

  const deleteMatches = async () => {
    setDeleteInProgress(true);
    const url = api_v3_delete_matches_by_group(groupId);
    try {
      console.log(`Saving....`);
      var access_token = accessToken || localStorage.getItem("access_token");
      if (!access_token) {
        console.error(
          `AdminGroupPlayerList :: deleteMatches -> it's necessary be logged`
        );
        return false;
      }
      const config = {
        headers: { Authorization: `Bearer ${access_token}` },
      };
      const response = await axios.delete(url, config);
      if (response.status === 200) {
        setDeleteInProgress(false);
        setDeleteError(false);
        return true;
      } else {
        setDeleteInProgress(false);
        setDeleteError(true);
        console.log(
          `(${response.status}) response: ${JSON.stringify(response.data)}`
        );
        return false;
      }
    } catch (error) {
      setDeleteInProgress(false);
      setDeleteError(true);
      return false;
    }
  };

  const generateMatchesRoundRobin = async () => {
    setGenerateMatchesInProgress(true);
    const url = api_v3_generate_matches_round_robin(
      tournamentId,
      divisionId,
      groupId
    );
    try {
      console.log(`Saving....`);
      var access_token = accessToken || localStorage.getItem("access_token");
      if (!access_token) {
        console.error(
          `AdminGroupPlayerList :: generateMatchesRoundRobin -> it's necessary be logged`
        );
        return false;
      }
      const config = {
        headers: { Authorization: `Bearer ${access_token}` },
      };
      const response = await axios.put(url, config);
      if (response.status === 200) {
        setGenerateMatchesInProgress(false);
        setGenerateMatchesError(false);
        return true;
      } else {
        setGenerateMatchesInProgress(false);
        setGenerateMatchesError(true);
        console.log(
          `(${response.status}) response: ${JSON.stringify(response.data)}`
        );
        return false;
      }
    } catch (error) {
      setGenerateMatchesInProgress(false);
      setGenerateMatchesError(true);
      return false;
    }
  };

  const publishLeagueDay = async (leagueDay) => {
    setPublishLeagueDayBtnInProgress(true);
    setPublishLeagueDayBtnDone(false);
    const url = api_v3_publish_matches_by_league_day(
      tournamentId,
      divisionId,
      groupId,
      leagueDay
    );
    try {
      var access_token = accessToken || localStorage.getItem("access_token");
      if (!access_token) {
        console.error(
          `AdminGroupPlayerList :: publishLeagueDay -> it's necessary be logged`
        );
        return false;
      }
      const config = {
        headers: { Authorization: `Bearer ${access_token}` },
      };
      const response = await axios.put(url, config);
      if (response.status === 200) {
        setPublishLeagueDayBtnInProgress(false);
        setPublishLeagueDayBtnError(false);
        setPublishLeagueDayBtnDone(true);
        return true;
      } else {
        setPublishLeagueDayBtnInProgress(false);
        setPublishLeagueDayBtnError(true);
        console.log(
          `(${response.status}) response: ${JSON.stringify(response.data)}`
        );
        return false;
      }
    } catch (error) {
      setPublishLeagueDayBtnInProgress(false);
      setPublishLeagueDayBtnError(true);
      return false;
    }
  };

  const addPlayerInGroupDESCANSA = () => {
    var temp = registersInGroup;
    temp.push(PLAYERDESCANSA);
    setNumRegistersInGroup(temp.length);
    setRegistersInGroup(
      temp.sort((a, b) =>
        a.username.toLowerCase() > b.username.toLowerCase() ? 1 : -1
      )
    );
    setDescansaInGroup(true);
  };

  if (regInProgress || groupInProgress || divisionsInProgress) {
    return (
      <Wrapper>
        <div className="loading">
          <div className="lds-dual-ring"></div>
        </div>
      </Wrapper>
    );
  }

  if (regError || groupError || divisionsError) {
    return (
      <Wrapper>
        <div className="error">
          Ha ocurrido un error cargando los inscritos y/o las divisiones
        </div>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <div className="title">
        <h2>Admin divisions</h2>
        <div className="underline"></div>
        <div className="header-options">
          <Link to={`/admin/tournament/${tournamentId}`} className="btn">
            <TfiAngleLeft />
            Volver
          </Link>
          <span>
            <b>División - grupo:</b> {groupName}
          </span>
        </div>
      </div>
      {matchesInProgress ? <Loading /> : ""}
      {matchesError ? "Error cargando info de partidos de este grupo" : ""}
      {!matchesInProgress && !matchesError ? (
        <div className="matches">
          <h4>Gestión del grupo</h4>
          <div className="content-matches">
            <p>Partidos: {matches.length}</p>
            <div className="btn" onClick={() => generateMatchesRoundRobin()}>
              {generateMatchesInProgress ? <Loading /> : ""}
              {generateMatchesError
                ? "Error generando partidos. Reintentar"
                : ""}
              {!generateMatchesInProgress && !generateMatchesError
                ? "Generar partidos (round robin)"
                : ""}
            </div>
            <div className="btn" onClick={() => deleteMatches()}>
              {deleteInProgress ? <Loading /> : ""}
              {deleteError ? "Error borrando partidos. Reintentar" : ""}
              {!deleteInProgress && !deleteError ? "Borrar partidos" : ""}
            </div>
          </div>
          {publishLeagueDayBtnDone ? (
            <div
              style={{
                backgroundColor: "var(--clr-green-dark)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              Jornada publicada correctamente
            </div>
          ) : (
            ""
          )}
          <div className="content-matches">
            {publishLeagueDayBtnInProgress ? <Loading /> : ""}
            {publishLeagueDayBtnError ? (
              <p>Ha ocurrido un error publicando la jornada. Reintentar</p>
            ) : (
              ""
            )}

            {!publishLeagueDayBtnError && !publishLeagueDayBtnInProgress
              ? [1, 2, 3, 4, 5, 6, 7, 8, 9].map((value) => (
                  <div
                    key={`publish-${value}`}
                    className="btn"
                    onClick={() => publishLeagueDay(value)}
                  >
                    Publicar jornada {value}
                  </div>
                ))
              : ""}
          </div>
        </div>
      ) : (
        ""
      )}
      <div className="content">
        <Column>
          <div className="column-header">
            <h3>Jugadores en el grupo: {numRegistersInGroup}</h3>
            <div className="btn" onClick={() => saveGroup()}>
              {!saveBtnInProgress && !saveBtnError && !saveBtnDone
                ? "Guardar cambios"
                : ""}
              {saveBtnError ? "ERROR! Reintentar" : ""}
              {saveBtnDone ? "GUARDADOS!!!" : ""}
              {saveBtnInProgress ? (
                <div className="lds-dual-ring-small"></div>
              ) : (
                ""
              )}
            </div>
            {!descansaInGroup ? (
              <div
                className="btn"
                onClick={() => addPlayerInGroupDESCANSA()}
                style={{ marginLeft: "1rem" }}
              >
                + DESCANSA
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="column-content">
            {numRegistersInGroup === 0 ? (
              <p>
                Haz click en el listado de jugadores inscritos para añadirlos al
                grupo
              </p>
            ) : (
              ""
            )}
            {registersInGroup &&
              registersInGroup.map((player) => {
                return (
                  <Player
                    key={`player-${
                      player.playerId ? player.playerId : player.playerId
                    }`}
                    className={`${
                      player.username === "DESCANSA" ? "descansa-player" : ""
                    }`}
                  >
                    <TfiClose onClick={() => removePlayerFromGroup(player)} />
                    <span onClick={() => removePlayerFromGroup(player)}>
                      {player.username}
                    </span>
                  </Player>
                );
              })}
          </div>
        </Column>
        <Column>
          <div className="column-header">
            <h3>Jugadores pendientes ({registersNotInGroup.length})</h3>
          </div>
          <div className="column-content">
            {registersNotInGroup.map((player) => {
              return (
                <Player
                  key={`player-${
                    player.playerId ? player.playerId : player.playerId
                  }`}
                >
                  <TfiPlus onClick={() => addPlayerInGroup(player)} />
                  <span onClick={() => addPlayerInGroup(player)}>
                    {player.username}
                  </span>
                </Player>
              );
            })}
          </div>
        </Column>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
  .title {
    margin-bottom: 4rem;
  }
  .content {
    display: flex;
  }

  .column-header {
    margin-bottom: 2rem;
  }
  .header-options {
    margin-top: 4rem;
  }
  .header-options > * {
    margin-left: 2rem;
    margin-right: 2rem;
  }
  .matches {
    background-color: var(--clr-dark-violet);
  }
  .content-matches {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 1rem;
  }
  .content-matches > * {
    margin: 1rem;
  }
  .descansa-player {
    color: var(--clr-playerB);
  }
`;
const Column = styled.div`
  width: 50%;
`;

const Player = styled.div`
  display: flex;
  align-items: center;
  * {
    cursor: pointer;
  }

  *:hover {
    color: var(--clr-primary-light-3);
  }

  span {
    margin-left: 1.2rem;
  }
`;

export default AdminGroupPlayerList;
